import React, { Component } from 'react';
import Dropdown from './dropDown';
import { sort } from '../../../services/utils';
import { toJS } from 'mobx';
import AuthenticationProviderType from '../../../services/enums/authenticationProviderType';

export default class AuthenticationProvidersDropownContainer extends Component {

    state = {
        providers: undefined
    };

    componentDidMount() {

        const internalAuthenticationProviders = 
                this.props.authenticationProviders
                    .filter(authProvider => authProvider.active && !authProvider.isExternal);

        let list = [];

        internalAuthenticationProviders.forEach(provider => {
            
            list.push({
                id: provider.id,
                name: provider.name
            });
        });

        list = sort(list)('name')('asc');

        this.setState({
            providers: list
        });
    }

    defaultAuthenticationProvider(providers){

        return providers.filter(a => 
            a.name.toLowerCase() === AuthenticationProviderType.Application.toLowerCase()
            )[0].id; 
    }

    selectedAuthenticationProvider(){

        let authenticationProviderId = this.props.selectedProviderId; 
        let providersJs = toJS(this.state.providers);      
   
        let chosenAuthenticationProvider = 
                providersJs.filter(authenticationProvider =>
                     authenticationProvider.id == authenticationProviderId);        
        
        if(chosenAuthenticationProvider.length == 0){
            
            authenticationProviderId = this.defaultAuthenticationProvider(providersJs);
        }

        return authenticationProviderId;
    }

    render() {

        if (this.state.providers === undefined) {
            
            return null;
        }

        const providerId = this.selectedAuthenticationProvider();

        return (
            <div>
                <Dropdown
                    list={this.state.providers}
                    select={this.props.selectProviderChange}
                    value={providerId}
                />
            </div>
        );   
    }
}


// WEBPACK FOOTER //
// ./src/components/account/authenticationProvidersDropown/index.jsx